module.exports = __webpack_public_path__ + "img/booking_request_black_icon.19a39deb.svg";